module.exports = __webpack_public_path__ + "img/expostyle_2134_purist_blue_pantone7458c.4cb00bf3.jpg";